"use strict";

var _interopRequireWildcard = require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var Quill = _interopRequireWildcard(require("quill"));
var _firmwarepair = require("../../api/firmwarepair.js");
var _uploads = require("../../api/uploads.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      data: {
        firmwareVersion: "",
        cnFixPoint: "",
        enFixPoint: "",
        hkFixPoint: "",
        jpFixPoint: "",
        //lan: "",
        type: '',
        taskType: ''
      },
      lanData: [],
      versionData: [],
      formLabelWidth: "100px",
      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"],
          //加粗，斜体，下划线，删除线
          ["blockquote", "code-block"],
          //引用，代码块
          [{
            header: 1
          }, {
            header: 2
          }],
          // 标题，键值对的形式；1、2表示字体大小
          [{
            list: "ordered"
          }, {
            list: "bullet"
          }],
          //列表
          [{
            script: "sub"
          }, {
            script: "super"
          }],
          // 上下标
          [{
            indent: "-1"
          }, {
            indent: "+1"
          }],
          // 缩进
          [{
            direction: "rtl"
          }],
          // 文本方向
          [{
            size: ["small", false, "large", "huge"]
          }],
          // 字体大小
          [{
            header: [1, 2, 3, 4, 5, 6, false]
          }],
          //几级标题
          [{
            color: []
          }, {
            background: []
          }],
          // 字体颜色，字体背景颜色
          [{
            font: []
          }],
          //字体
          [{
            align: []
          }],
          //对齐方式
          ["image"] //清除字体样式 //['image','video']        //上传图片、上传视频
          ]
        },
        theme: "snow",
        placeholder: "请输入文本信息..."
      },
      addRange: [],
      Rangeflag: false,
      isRepeat: false,
      isDisable: false,
      rulesadd: {
        //lan: [{ required: true, trigger: "change" }],
        firmwareVersion: [{
          required: true,
          trigger: "change"
        }],
        type: [{
          required: true,
          trigger: "change"
        }],
        taskType: [{
          required: true,
          trigger: "change"
        }]
      },
      system: [{
        value: '1',
        valueCn: 'Linux'
      }, {
        value: '2',
        valueCn: 'Android'
      }],
      taskTypes: [{
        value: '1',
        valueCn: '测试'
      }, {
        value: '2',
        valueCn: '发布'
      }],
      versionflag: false,
      versionflags: false
    };
  },
  mounted: function mounted() {
    // 为图片ICON绑定事件  getModule 为编辑器的内部属性
    this.$refs.myQuillEditor.quill.getModule("toolbar").addHandler("image", this.imgHandler);
  },
  methods: {
    imgHandler: function imgHandler(state) {
      this.addRange = this.$refs.myQuillEditor.quill.getSelection();
      if (this.addRange != "" && this.addRange != null) {
        this.Rangeflag = true;
      }
      if (state) {
        var fileInput = document.getElementById("imgInput");
        fileInput.click(); // 加一个触发事件
      }
    },
    to_upload_img: function to_upload_img(formdata) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        var fd = new FormData();
        fd.append("file", formdata.file);
        (0, _uploads.uploads)(fd).then(function (res) {
          if (_this.Rangeflag) {
            _this.addRange = _this.$refs.myQuillEditor.quill.getSelection();
            _this.$refs.myQuillEditor.quill.insertEmbed(_this.addRange !== null ? _this.addRange.index : 0, "image", res.voT.downloadUrl, Quill.sources.USER); // 调用编辑器的 insertEmbed 方法，插入URL
            _this.Rangeflag = false;
          }
        });
      });
    },
    //根据系统查询版本
    getversions: function getversions() {
      if (this.data.type == '1') {
        this.versionflag = true;
        this.versionflags = false;
        this.data.firmwareVersion = "";
      } else if (this.data.type == "2") {
        this.versionflag = false;
        this.versionflags = true;
        this.data.firmwareVersion = "";
      }
    },
    getLan: function getLan() {
      var _this2 = this;
      (0, _firmwarepair.getLanList)({
        name: "lan"
      }).then(function (res) {
        _this2.lanData = res.dictionaryVOList;
      });
    },
    //查询固件版本号列表
    getVersion: function getVersion() {
      var _this3 = this;
      (0, _firmwarepair.getFirmwareVersionList)({
        status: ""
      }).then(function (res) {
        _this3.versionData = res.voList;
      });
    },
    submit: function submit() {
      var _this4 = this;
      this.$refs.data.validate(function (valid) {
        /* if (this.data.fixPoint == "" || this.data.fixPoint == null) {
           this.data.fixPoint =
             '<p><strong style="color: rgb(230, 0, 0);"><em>请输入修复点信息(不可为空)</em></strong></p>';
           return false;
         }*/
        if (valid) {
          _this4.isRepeat = true;
          _this4.isDisable = true;
          (0, _firmwarepair.addFirmwareFixpoint)(_this4.data).then(function (res) {
            if (res.success) {
              _this4.$message({
                type: "success",
                message: "添加成功",
                center: true
              });
              _this4.$store.dispatch("tagsView/delView", _this4.$route).then(function () {
                _this4.$nextTick(function () {
                  _this4.$router.replace({
                    path: "/firmware/firwarerepair"
                  });
                });
              });
            } else {
              _this4.$message({
                type: "warning",
                message: res.errorMsg,
                center: true
              });
              _this4.isRepeat = false;
              _this4.isDisable = false;
            }
          });
        } else {
          _this4.$message({
            type: "warning",
            message: "请填写完整",
            center: true
          });
        }
      });
    }
  }
};